import { Account } from '@tcs/client-portal-api/types/Account';
import { AccountSearchResult } from '@tcs/client-portal-api/types/AccountSearchResult';

export const DECEASED_LEVY_CODES = ['Deceased', 'DeathNotification'] as const;

export const isDeceasedAccount = (account?: Account): boolean => {
  if (!account?.levyCode) {
    return false;
  }
  const normalizedLevyCode = account.levyCode.trim().toLowerCase();
  return (DECEASED_LEVY_CODES as readonly string[]).some(
    (code) => code.toLowerCase() === normalizedLevyCode,
  );
};

export const isTemporaryAccount = (accountNumber?: string) => {
  if (!accountNumber) {
    return false;
  }

  return /[A-Za-z]$/.test(accountNumber.trim());
};

export const getClientNames = (accounts: AccountSearchResult[] = []) => {
  return [
    ...new Set(
      accounts
        .map((item) => item?.name)
        .filter((name) => typeof name === 'string'),
    ),
  ];
};
export const getAccounts = (accounts: AccountSearchResult[] = []) => {
  return [
    ...new Set(
      accounts.map((item) => item?.id).filter((id) => typeof id === 'string'),
    ),
  ];
};
export const getAccountIdsByClient = (
  accounts: AccountSearchResult[],
  clientNames: string[],
) => {
  const filteredAccounts = accounts.filter((account) =>
    clientNames.includes(account.name),
  );

  const distinctIds = [
    ...new Set(
      filteredAccounts
        .map((account) => account.id)
        .filter((id) => typeof id === 'string'),
    ),
  ];
  return distinctIds;
};
